import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {NavbarComponent} from "./navbar.component";
import {RouterModule} from "@angular/router";
import {NavbarService} from "./navbar.service";
import { CryptoSymbol2NamePipe } from './cryptosymbol2name.pipe';
import { PartsModule } from '../../parts/parts.module';

@NgModule({
  declarations: [
    NavbarComponent,
    CryptoSymbol2NamePipe
  ],
  exports: [
    NavbarComponent,
    CryptoSymbol2NamePipe
  ],
  providers: [
    NavbarService
  ],
  imports: [
    CommonModule,
    RouterModule,
    PartsModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class NavbarModule {

}
